export class MFAResetPayload {
	userEmail: string;

	constructor(userEmail: string) {
		this.userEmail = userEmail;
	}
}
